const AntiguaAndBarbudaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_110768)">
      <path
        d="M0 20.0006C0 21.3705 0.138125 22.7082 0.400547 24.0006L20 25.218L39.5995 24.0006C39.862 22.7082 40 21.3705 40 20.0006C40 18.6307 39.8619 17.293 39.5995 16.0006L20 14.7832L0.400547 16.0006C0.138125 17.293 0 18.6307 0 20.0006H0Z"
        fill="#0052B4"
      />
      <path
        d="M39.5994 24H0.400391C2.25344 33.1289 10.3241 40 19.9998 40C29.6755 40 37.7463 33.1289 39.5994 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M0.400391 16H39.5995C37.7463 6.87109 29.6757 0 19.9998 0C10.324 0 2.25344 6.87109 0.400391 16Z"
        fill="black"
      />
      <path
        d="M28.6954 15.9996H11.3042L14.8573 14.3282L12.9652 10.8872L16.8234 11.6251L17.3125 7.72754L19.9998 10.5943L22.6873 7.72754L23.1761 11.6251L27.0344 10.8872L25.1425 14.3284L28.6954 15.9996Z"
        fill="#FFDA44"
      />
      <path
        d="M0 19.9997C0 31.0454 8.95437 39.9997 20 39.9997L3.99969 7.99902C1.48844 11.3419 0 15.4968 0 19.9997Z"
        fill="#A2001D"
      />
      <path
        d="M20 39.9997C31.0456 39.9997 40 31.0454 40 19.9997C40 15.4968 38.5116 11.3419 36.0003 7.99902L20 39.9997Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110768">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AntiguaAndBarbudaSvg;
